const DEFAULT_TTL_MS = 2 * 60 * 1000;

const canUseStorage = () => typeof window !== "undefined" && window.localStorage;

export const readPublicCache = (key, { allowStale = false } = {}) => {
  if (!canUseStorage()) return null;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object" && "data" in parsed) {
      if (allowStale || !parsed.expiresAt || parsed.expiresAt > Date.now()) {
        return parsed.data;
      }
      return null;
    }
    return allowStale ? parsed : null;
  } catch (_) {
    return null;
  }
};

export const writePublicCache = (key, data, ttlMs = DEFAULT_TTL_MS) => {
  if (!canUseStorage()) return;
  try {
    window.localStorage.setItem(
      key,
      JSON.stringify({
        data,
        savedAt: Date.now(),
        expiresAt: Date.now() + ttlMs,
      })
    );
  } catch (_) {}
};

export const cacheDataEqual = (a, b) => {
  try {
    return JSON.stringify(a) === JSON.stringify(b);
  } catch (_) {
    return false;
  }
};

export const preloadImage = (src) => {
  if (typeof window === "undefined" || !src || src.startsWith("data:")) return;
  const img = new window.Image();
  img.decoding = "async";
  img.src = src;
};
